import fs from 'fs';
import path from 'path';
import matter from 'gray-matter';
import { NextPageWithLayout } from './_app';
import Layout from 'components/Layout';
import TextPage from 'components/TextPage';
import { GetServerSideProps } from 'next';
import { serverSideTranslations } from 'next-i18next/pages/serverSideTranslations';

interface ITermsAndConditionsProps {
  content: string | null;
  frontmatter: { title: string };
}

const TermsAndConditions: NextPageWithLayout<ITermsAndConditionsProps> = ({
  frontmatter: { title },
  content,
}) => {
  return <TextPage title={title} content={content} />;
};

TermsAndConditions.getLayout = (page: React.ReactElement) => (
  <Layout
    navBarClassName="bg-white py-6"
    titleProduction="meta_title_terms"
    titleStaging="Terms and conditions"
    metaDescriptionProd="meta_description_production_terms"
    metaDescriptionStaging=" Allmyles API terms and conditions lets you understand commercial terms and legal conditions of API usage"
    canonicalProd="https://tipptour.com/terms-and-conditions"
    canonicalStaging="https://showcase.allmyles.com/terms">
    {page}
  </Layout>
);
export default TermsAndConditions;

export const getServerSideProps: GetServerSideProps = async ({ locale }) => {
  const env = process.env.NEXTJS_NODE_ENV === 'production' ? 'prod' : 'dev';
  try {
    const markdownWithMeta = fs.readFileSync(
      path.join(
        process.cwd(),
        `assets/localization/terms_and_conditions/${env}/${locale}.md`,
      ),
      'utf-8',
    );
    const { data: frontmatter, content } = matter(markdownWithMeta);
    return {
      props: {
        frontmatter: JSON.parse(JSON.stringify(frontmatter)),
        content: content,
        ...(await serverSideTranslations(locale || 'en')),
      } as ITermsAndConditionsProps,
    };
  } catch (err) {
    return {
      props: {
        frontmatter: { title: '' },
        content: null,
        ...(await serverSideTranslations(locale || 'en')),
      } as ITermsAndConditionsProps,
    };
  }
};
